<template>
  <div class="chartDom" ref="chartDom"></div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      msg: '饼图-半径模式',
      echartParams: this.data,
      timeId: null,
      myChart: null
    }
  },
  created() {},
  mounted() {
    this.drawLineCustom(this.echartParams)
  },
  destroyed() {
    clearInterval(this.timeId)
  },
  methods: {
    drawLineCustom(params) {
      this.myChart = this.$echarts.init(this.$refs.chartDom)
      let option = {
        tooltip: {
          trigger: 'item'
        },
        color: params.map(item => item.color),
        legend: {
          show: false,
          // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
          orient: 'vertical',
          icon: 'circle',
          right: '100',
          top: '20',
          itemWidth: 8, // 设置图例图形的宽
          itemHeight: 8, // 设置图例图形的高
          textStyle: {
            color: '#6C7482',
            fontSize: 12 // 图例文字颜色
          },
          itemGap: 14
        },
        series: [
          {
            name: '人数',
            type: 'pie',
            minAngle: '0',
            avoidLabelOverlap: true, // 是否启用防止标签重叠策略
            radius: ['35%', '45%'],
            center: ['50%', '50%'],
            padAngle: 5,
            itemStyle: {
              borderRadius: 5
            },
            label: {
              normal: {
                formatter: '{bValue|{b}}\n{dValue|{d}%}',
                rich: {
                  dValue: {
                    height: 15,
                    fontSize: 16,
                    color: '#3B4F6A',
                    fontFamily: 'DingTalk'
                  },
                  bValue: {
                    height: 20,
                    fontSize: 12,
                    color: '#3B4F6A',
                    fontFamily: 'DingTalk'
                  }
                }
              }
            },

            labelLine: {
              show: true,
              lineStyle: {
                width: 2
              },
              length: 5
            },
            data: params
              ? params
              : [
                  { value: 0, name: '-' },
                  { value: 0, name: '-' },
                  { value: 0, name: '-' }
                ]
          }
        ]
      }

      this.myChart.setOption(option, true)

      window.addEventListener('resize', () => {
        if (this.myChart) {
          this.myChart.resize()
        }
      })
    }
  },

  watch: {
    data: {
      immediate: true,
      deep: true,
      handler: function(newValue, oldValue) {
        console.log("newValue体育管理人员(在编)",newValue);
        this.$nextTick(() => {
          clearInterval(this.timeId)
          this.drawLineCustom(newValue)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.chartDom {
  width: 70%;
  height: calc(100% - 30px);
}
</style>
